import React from 'react'
import { SearchIcon } from '../../../assets/icons'
import Modal from '..'
import { Button } from '../../ui/button'
import CheckList from '../../ui/checkList'
import Input from '../../ui/input'
import Tag from '../../ui/tag'
import {
	ModalActions,
	SelectedTagsContainer,
	TagsLabel,
	TagsRow
} from './styled'

const SearchCheckListModal = ({
	isOpen,
	onClose,
	title = '¿Qué estás buscando?',
	searchPlaceholder = 'Buscá una especialidad',
	searchValue,
	onSearchChange,
	options = [],
	selectedValues = [],
	onToggle,
	onConfirm,
	onCancel,
	selectedTags = [],
	tagsLabel = 'Especialidades seleccionadas:',
	onRemoveSelected,
	confirmLabel = 'Confirmar',
	cancelLabel,
	confirmDisabled = false,
	emptyText = 'No hay opciones para mostrar',
	maxHeight = '184px',
	maxHeightMobile,
	widthDesktop = '480px',
	isMobile = false,
	componentContainerProps
}) => {
	if (!isOpen) return null

	const defaultContainerProps = {
		$alignItems: 'stretch',
		$padding: '72px 24px 24px 24px',
		$paddingDesktop: '72px 24px 24px 24px',
		$gap: '24px',
		$height: isMobile ? '100%' : '662px'
	}

	return (
		<Modal
			onClose={onClose}
			widthDesktop={widthDesktop}
			withComponentContainer
			isFullHeight={isMobile}
			withMainSection={isMobile}
			mainSectionProps={{
				$grow: true,
				$gap: '24px'
			}}
			componentContainerProps={componentContainerProps || defaultContainerProps}
			title={title}
			buttons={
				<ModalActions>
					<Button
						label={confirmLabel}
						onClick={onConfirm}
						size={isMobile ? 'mobile' : 'large'}
						disabled={confirmDisabled}
					/>
					{cancelLabel && (
						<Button
							label={cancelLabel}
							onClick={onCancel || onClose}
							type="button"
							size="text"
							$variant="tertiary"
							alignSelf="center"
							$mt="0"
							$showBorder={false}
						/>
					)}
				</ModalActions>
			}
		>
			<Input
				type="text"
				placeholder={searchPlaceholder}
				value={searchValue}
				onChange={onSearchChange}
				startAdornment={<SearchIcon />}
				fullWidth
				autoFocus
			/>
			{selectedTags.length > 0 && (
			<SelectedTagsContainer>
				<TagsRow>
					<TagsLabel>{tagsLabel}</TagsLabel>
					{selectedTags.map(tag => (
						<Tag
							key={tag.value}
							label={tag.label}
							onRemove={() => onRemoveSelected && onRemoveSelected(tag.value)}
						/>
					))}
				</TagsRow>
			</SelectedTagsContainer>
			)}
			<CheckList
				options={options}
				selectedValues={selectedValues}
				onToggle={onToggle}
				maxHeight={maxHeight}
				maxHeightMobile={maxHeightMobile}
				searchedText={searchValue}
			/>
		</Modal>
	)
}

export default SearchCheckListModal
